/**
 * @file
 * @fileOverview Demo for using MarkdownDisplay with VirtualScreen
 * @version 1.0.0
 * @date 2025-03-22
 */

import VirtualScreen from '../virtualScreen.js';
import MarkdownDisplay from './VersonaMarkdownScreen.js';
// Make sure you have installed the showdown package
// npm install showdown --save

// Create a basic Phaser scene with a markdown display
const createVirtualScreenWithMarkdown = (planeId, x_pos, y_pos, z_pos) => {
  // Define the plane ID for the virtual screen
planeId = planeId || 'markdown-screen';
  
  // Sample markdown content to display
  const sampleMarkdown = `# Markdown Display Demo
  
This is a **bold text** demonstration and *italic text* as well.

## Features
- Markdown rendering in VR/AR environments
- Scrollable content
- Support for headings, lists, and basic formatting
- Tables and other advanced markdown features

## Code Example
    function hello() {
      console.log('Hello from markdown!');
    }

---

Try scrolling to see more content!

### How It Works
The MarkdownDisplay component renders formatted text on a virtual screen using the Showdown library for markdown parsing.

| Feature | Support |
|---------|---------|
| Headings | ✓ |
| Lists | ✓ |
| Code blocks | ✓ |
| Tables | ✓ |
| Links | ✓ |

> This component supports blockquotes and other advanced formatting!

#### Try Different Formats
1. Ordered lists work too
2. With automatic numbering
3. And proper formatting

Visit [Showdown's site](https://showdownjs.com/) for more info on supported syntax.`;

  // VirtualScreen requires these three Phaser scene functions
  const preload = function(scene) {
    // Preload any assets here if needed
  };

  const create = function(scene) {
    // Create the markdown display component

    
    // Example of how to update content later
    // Uncomment to test:
    /*
    scene.time.delayedCall(5000, () => {
      markdownDisplay.setText('# Updated Content\n\nThis content was updated after 5 seconds.');
    });
    */
  };

  const update = function(scene) {
    // Update logic if needed
  };

  // Create the virtual screen with the markdown display
  var virtualScreen = new VirtualScreen(
    planeId,             // ID of the A-Frame plane element
    800,                 // Width of the virtual screen
    600,                 // Height of the virtual screen
    (game)=>{
        var markdownDisplay = new MarkdownDisplay(
            game,              // Phaser scene reference
            'md-display',       // Unique component ID
            400,  // X position (center of screen)
            300,  // Y position (center of screen)
            760, // Width (with margin)
            540, // Height (with margin)
            sampleMarkdown,     // Initial markdown text
            {
              backgroundColor: '#2D2D2D',
              textColor: '#FFFFFF',
              fontSize: '18px',
              fontFamily: 'Arial, sans-serif',
              padding: 30,
              scrollable: true,
              // Showdown converter options
              showdownOptions: {
                tables: true,
                tasklists: true,
                strikethrough: true,
                simpleLineBreaks: true,
                emoji: true
              }
            }
          );
          
          // Add the markdown display to the virtual screen
          virtualScreen.addComponent(markdownDisplay);
          game.add.existing(markdownDisplay);
    },             // Preload function
    update,              // Update function
    (game)=>{

    },              // Create function
    { x: x_pos, y: y_pos, z: z_pos }, // Position in 3D space
    {
      antialiasing: true,
      textureQuality: 'high',
      dynamicResolution: true,
      pixelRatio: window.devicePixelRatio || 1
    }
  );
  
  return virtualScreen;
};

export default createVirtualScreenWithMarkdown;